import React from 'react';

import { SVGComponentProps } from './svg.types';

const GavelSVG = ({
  stroke = 'currentColor',
  size = '1em',
  ...otherProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M9.3334 8.66675L4.3334 13.6667C3.78007 14.2201 2.88674 14.2201 2.3334 13.6667C2.20198 13.5355 2.09771 13.3796 2.02658 13.208C1.95544 13.0364 1.91882 12.8525 1.91882 12.6667C1.91882 12.481 1.95544 12.2971 2.02658 12.1255C2.09771 11.9539 2.20198 11.798 2.3334 11.6667L7.3334 6.66675"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6666 10.6667L14.6666 6.66675"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33337 5.33325L9.33337 1.33325"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 4.66675L11.3333 10.0001"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 7.33333L8.66663 2"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GavelSVG;
